<ng-container
  *ngIf="ancillaryUpsellNode$ | async as ancillaryUpsellNode; else loadingOrErrorTemplate"
>
  <header [salesAgent]="ancillaryUpsellNode.salesAgent" class="header"></header>

  <div class="d-flex mx-auto pt-md-10 content justify-content-center">
    <router-outlet />
  </div>

  <footer></footer>
</ng-container>

<ng-template #loadingOrErrorTemplate>
  <ng-container *ngIf="errorState; else loadingTemplate">
    <header class="header"></header>

    <div class="d-flex mx-auto pt-md-10 content justify-content-center">
      <router-outlet />
    </div>
  </ng-container>
</ng-template>

<ng-template #loadingTemplate>
  <lead-loading-page />
</ng-template>
